import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { io } from "socket.io-client";
import { SOCKET_BASEURL } from "../components/config/constants";

const defaultVal = { socket: null };
export const SocketContext = React.createContext(defaultVal);

function SocketContextProvider({ children, loggedUserInfo }) {
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    const userId = loggedUserInfo?.userData?._id;
    const sessionId = loggedUserInfo?.userData?.sessionDetails?._id;

    const socketObj = io(SOCKET_BASEURL, {
      transports: ["websocket"],
      auth: { userId },
    });
    socketRef.current = socketObj;

    socketObj.on("connect", () => {
      if (userId && sessionId) {
        socketObj.emit("on_connect", {
          userId,
          sessionId,
          connectionId: socketObj.id,
        });
        setSocket(socketObj);
      }
      window["socket_id"] = socketObj.id;
    });

    return () => {
      socketObj.disconnect();
    };
  }, [
    loggedUserInfo?.userData?._id,
    loggedUserInfo?.userData?.sessionDetails?._id,
  ]);

  return (
    <SocketContext.Provider value={{ socket, setSocket }}>
      {children}
    </SocketContext.Provider>
  );
}

const mapStateToProps = (state) => ({
  loggedUserInfo: state.authentication,
});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SocketContextProvider);
